export default __webpack_public_path__ + "static/media/partners-logo-techstorm-w@2x.5b491e2d.webp";